import { render } from "./AboutEng.vue?vue&type=template&id=745a986a"
import script from "./AboutEng.vue?vue&type=script&lang=js"
export * from "./AboutEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__